namespace TabAurous.Stock {
    export namespace ProductPerformanceService {
        export const baseUrl = 'Stock/ProductPerformance';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductTypeList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/ProductPerformance/List",
            ProductTypeList = "Stock/ProductPerformance/ProductTypeList"
        }

        [
            'List', 
            'ProductTypeList'
        ].forEach(x => {
            (<any>ProductPerformanceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
